<template>
  <div
    v-bind:style="{
      backgroundImage: product.thumbnail && `url(${product.thumbnail.url})`,
    }"
    class="product"
  >
    <div
      class="overlay"
      :class="shoppingCardInfo > 0 ? 'selected-overlay' : ''"
      @click="selectProduct"
    >
      <div v-if="product.featured || product.discount > 0" class="specials">
        <span v-show="product.featured" class="special-item featured">{{
          "ویژه"
        }}</span>
        <span v-show="product.discount > 0" class="special-item discount"
          >{{ product.discount }}%</span
        >
      </div>
      <div class="product-details">
        <div class="name-cont" :class="!product.available ? 'unavailable' : ''">
          <div v-if="shoppingCardInfo > 0" class="counter-cont">
            <p class="counter">{{ shoppingCardInfo }}</p>
          </div>
          <p class="name">{{ product.title }}</p>
        </div>
        <p v-if="product.price > 0" class="price">
          {{
            (product.price / 10)
              .discountDistinct(product.discount)
              .toString()
              .numberFormat()
          }}
          تومان
        </p>
        <p v-if="product.price > 0 && product.discount > 0" class="main-price">
          {{ (product.price / 10).toString().numberFormat() }}
        </p>
      </div>
    </div>
    <div v-if="!product.available">
      <img
        src="../../../assets/images/unavailable.png"
        alt="unavailable"
        class="unavailable-image"
      />
    </div>
    <div
      v-if="shoppingCardInfo > 0"
      class="delete-cont"
      @click="$emit('remove')"
    >
      <vs-button
        color="danger"
        block
        icon-pack="feather"
        size="small"
        icon="icon-minus"
        class="delete"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Product",
  computed: {
    shoppingCardInfo() {
      let counter = 0;
      this.shoppingCard.forEach((item) => {
        if (item.id === this.product.id) {
          counter++;
        }
      });
      return counter;
    },
  },
  methods: {
    selectProduct() {
      if (!this.product.available) {
        this.$vs.notify({
          text: "محصول مورد نظر موجود نمیباشد.",
          color: "warning",
          position: "bottom-center",
        });
        return;
      }

      this.$emit("select");
    },
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    shoppingCard: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.product {
  position: relative;
  border-radius: 5px;
  margin: 1px;
  height: 85px;
  overflow: hidden;
  cursor: pointer;
  user-select: none;
  text-align: center;
  transition: 0.3s all;
  background-position: center;
  background-size: cover;

  .overlay {
    flex: 1;
    display: flex;
    height: 100%;
    background-color: rgba($color: #232323, $alpha: 0.95);
    flex-direction: column;
  }

  img {
    display: block;
  }

  .product-details {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .name-cont {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 80%;

    .counter-cont {
      background-color: #e0e0e0;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 20px;
      width: 20px;
      position: absolute;
      top: 5px;
      left: 5px;

      .counter {
        font-size: 13px;
        color: #232323;
        font-weight: bold;
      }
    }

    .name {
      font-size: 14px;
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #fff;

      @media (max-width: 440px) {
        font-size: 12px;
      }
    }
  }

  .price {
    font-size: 11px;
    font-weight: 700;
    color: gray;
    margin-top: 2px;
  }

  .main-price {
    font-size: 11px;
    text-decoration: line-through;
    color: gray;
    font-weight: 700;
  }

  .product-image {
    height: 130px;
    object-fit: cover;
    object-position: center;
  }

  .delete-cont {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 8px;

    .delete {
      width: 16px !important;
      height: 16px !important;
      border-radius: 50%;
    }
  }

  .specials {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .special-item {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f44336;
      padding: 0 5px;
      border-radius: 5px;
      box-shadow: 0 7px 24px 0 rgba(244, 67, 54, 0.4);
      color: white;
      font-size: 0.8rem;
      margin: 5px;
      height: 16px;
    }

    .featured {
      font-weight: 100;
      padding-bottom: 2px;
    }

    .discount {
      margin-left: 0;
    }
  }
}

.unavailable-image {
  position: absolute;
  top: 5px;
  left: -15px;
  width: 75px;
  transform: rotate(-45deg);
}

.selected-overlay {
  box-shadow: 0 0 15px 2px rgba(244, 67, 54, 0.4) inset;
}
</style>
